import Axios from 'axios'

import { SERVER_BASE_URL } from '../baseUrl'

export const deleteProfileVisiteur = async (token: string) => {
  try {
    const response = await Axios.delete(`${SERVER_BASE_URL}api/profileVisiteur/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
